import { useCallback, useMemo, useReducer } from 'react';

import type { Notification } from './reducer';
import { NotificationManagerReducer } from './reducer';

export type UseNotificationManagerReturn = ModelHookResult<
	{
		notification?: Notification;
	},
	{
		addNotification: (notification: Notification) => void;
		removeNotification: (id: string) => void;
		clearNotifications: () => void;
	}
>;

export function useStarterDashboardV2PageNotificationManager(): UseNotificationManagerReturn {
	const [notifications, dispatch] = useReducer(NotificationManagerReducer, []);

	return {
		data: {
			notification: useMemo(() => (notifications.length > 0 ? notifications[0] : undefined), [notifications]),
		},
		actions: {
			addNotification: useCallback(
				(notification: Notification) => {
					dispatch({ type: 'ADD_NOTIFICATION', payload: notification });
					setTimeout(() => {
						dispatch({ type: 'REMOVE_NOTIFICATION', payload: { id: notification.id } });
					}, 5000); // Automatically remove after 5 seconds
				},
				[dispatch],
			),
			removeNotification: useCallback(
				(id: string) => {
					dispatch({ type: 'REMOVE_NOTIFICATION', payload: { id } });
				},
				[dispatch],
			),
			clearNotifications: useCallback(() => {
				dispatch({ type: 'CLEAR_NOTIFICATIONS', payload: { id: '' } }); // Clear all notifications
			}, [dispatch]),
		},
	};
}
